import $ from 'jquery';

class JournalFilter {

  constructor() {
  }

  init() {

    this.$filterForm = $('#journal-filter-form');
    this.$tpaSelect = $('#journal-tpa-filter');
    this.$usersSelect = $('#journal-users-filter');
    this.$clearButton = $('#journal-filter-clear');
  }

  setupEvents() {

    let _this = this;

    this.$clearButton.click(function() {
      _this.$tpaSelect.val('');
      _this.$usersSelect.val('');
      _this.$usersSelect.trigger("chosen:updated");
      _this.$filterForm.submit();
    });
  }

  updateUI() {

  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new JournalFilter();
